import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
  moduleId: module.id,
  selector: "history-field",
  template: `<div>{{ params.data.eventId }}</div>`,
  styles: [
    `
      .btn {
        line-height: 0.5;
      }
    `,
  ],
})
export class HistoryFieldComponent implements ICellRendererAngularComp {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/history_field.component.ts